import { Navigate } from 'react-router-dom';

export function Root() {
  return <Navigate to="/c/new" replace />;
}
